<div class="dialog-container">
  <div class="close-button" (click)="close()">
    <app-svg-icon name="close"></app-svg-icon>
  </div>
  <app-lets-start-new-package [showPictureAndSvg]="showPictureAndSvg" [applyCustomStyling]="applyCustomStyling" [selectedPackageData]="selectedPackageData"
    [showTutorLevelOptions]="showTutorLevelOptions" (onClose)="dialogRef.close()" [tutorObj]="tutorObj"
    (onNewPackagePurchase)="onNewPackagePurchase.emit(); dialogRef.close()"></app-lets-start-new-package>
</div>